

























































































































































































































































































import Vue from 'vue';
import { mapActions, mapMutations, mapState } from 'vuex';
import {
  HubButton,
  HubCard,
  HubCheckbox,
  HubIcon,
  HubModal,
} from '@/components/HubComponents';

export default Vue.extend({
  name: 'LiveSocialCard' as string,

  components: {
    HubButton,
    HubCard,
    HubCheckbox,
    HubIcon,
    HubModal,
  },

  props: {
    disableCheckbox: {
      type: Boolean,
      default: false,
    },
    indexProvider: {
      type: Number,
      required: true,
    },
    liveActive: {
      type: Boolean,
      default: false,
    },
    provider: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      isDeletingAccountButtonLoading: false,
      isExpanded: false,
      isRemoveServiceButtonLoading: false,
      modalDeleteAccount: false,
      modalRemoveService: false,
      serviceIdToBeRemoved: '',
    };
  },

  computed: {
    ...mapState(['liveSocial', 'events']),
    eventsState(): Store.Events.State {
      return this.events;
    },
    eventState(): Store.Events.Event | undefined {
      return this.eventsState.event;
    },
    account(): Store.LiveSocial.LiveSocialNetwork | Store.LiveSocial.UserSocialNetwork {
      return this.liveSocial.providers[this.provider][this.indexProvider];
    },
    maxHeight(): number | null {
      if (this.provider !== 'facebook' || this.isExpanded) return null;
      return 155;
    },
    socialNetworkName(): string | null {
      return this.provider !== 'custom'
        ? this.firstCapitalLetter(this.provider)
        : null;
    },
    userData(): Store.LiveSocial.Facebook.UserData | null {
      return 'user_data' in this.account ? this.account.user_data : null;
    },
  },

  methods: {
    ...mapActions({
      deleteService: 'liveSocial/deleteService',
      deleteUserAccount: 'liveSocial/deleteUserAccount',
      facebookDeleteUser: 'liveSocial/facebookDeleteUser',
      facebookRemoveStreamTarget: 'liveSocial/facebookRemoveStreamTarget',
      youtubeRemoveStreamTarget: 'liveSocial/youtubeRemoveStreamTarget',
    }),
    ...mapMutations('liveSocial', ['setSelectedServices']),
    async facebookDeleteAccount(): Promise<void> {
      this.isDeletingAccountButtonLoading = true;

      const account = this.account as Store.LiveSocial.UserSocialNetwork;
      const promises = [] as Promise<void>[];

      if (account.lives) {
        account.lives.forEach((service) => {
          promises.push(this.removeService(service));
        });

        Promise.all(promises).then(() => {
          this.facebookDeleteUser({
            userId: account.user_id,
          } as Services.LiveSocial.Facebook.DeleteUser)
            .then(() => {
              this.deleteUserAccount({
                accountId: account.id,
                indexProvider: this.indexProvider,
                provider: this.provider,
              } as Store.LiveSocial.Actions.DeleteUserAccount)
                .then(() => {
                  this.isDeletingAccountButtonLoading = false;
                  this.modalDeleteAccount = false;
                });
            });
        });
      } else {
        this.facebookDeleteUser({
          userId: account.user_id,
        } as Services.LiveSocial.Facebook.DeleteUser)
          .then(() => {
            this.deleteUserAccount({
              accountId: account.id,
              indexProvider: this.indexProvider,
              provider: this.provider,
            } as Store.LiveSocial.Actions.DeleteUserAccount)
              .then(() => {
                this.isDeletingAccountButtonLoading = false;
                this.modalDeleteAccount = false;
              });
          });
      }
    },
    setTargetName(data: Services.LiveSocial.Facebook.SetTargetName): string {
      const {
        customerPlanName,
        provider,
        streamType,
        transmissionId,
      } = data;

      const providers = {
        custom: 'OT', // OT = others
        facebook: 'FB',
        instagram: 'IT',
        twitch: 'TC',
        twitter: 'TW',
        youtube: 'YT',
      };

      return `${providers[provider]}-${streamType}-${customerPlanName}-${transmissionId}`;
    },
    selectedServiceToggle(service: Store.LiveSocial.LiveSocialNetwork, value: boolean): void {
      this.$emit('input', { ...service, selected: value });

      this.setSelectedServices({
        providers: [this.provider],
        select: value,
        servicesIds: [service.id],
      } as Store.LiveSocial.Mutations.SetSelectedServices);
    },
    async removeService(service: Store.LiveSocial.LiveSocialNetwork): Promise<void> {
      this.isRemoveServiceButtonLoading = true;

      await this.deleteService({
        indexProvider: this.indexProvider,
        provider: this.provider,
        serviceId: service.id,
      } as Store.LiveSocial.Actions.DeleteService);

      // if povider is facebook remove target
      if (this.provider === 'facebook') {
        await this.facebookRemoveStreamTarget({
          application: `LVW-${this.eventState?.customer_plans_lvw_id}`,
          streamtargetname: service.process_name,
        } as Services.LiveSocial.Facebook.RemoveWowzaTarget);
      } else if (this.provider === 'youtube') {
        // await this.youtubeRemoveStreamTarget({
        //   application: `LVW-${this.eventState?.customer_plans_lvw_id}`,
        //   streamtargetname: this.setTargetName({
        //     customerPlanName: `EVT-${this.eventState?.customer_plans_id}`,
        //     provider: 'youtube',
        //     streamType: 'NOW',
        //     transmissionId: service.transmission_id,
        //   }),
        // } as Services.LiveSocial.Youtube.RemoveWowzaTarget);
      }

      this.isRemoveServiceButtonLoading = false;
      this.modalRemoveService = false;
    },
    firstCapitalLetter(value: string): string {
      return `${value.slice(0, 1).toUpperCase()}${value.slice(1).toLowerCase()}`;
    },
  },
});
